import { useState } from 'react'
import { MAX_VOLUME } from '../constants'
import { normalizeVolume } from '../PlayerControls/playerControlsUtils'

interface RRWebPlayerStateOptions {
  initialVolumePercentage?: number
  onPlayerVolumePercentageChange?: (volumePercentage: number) => void
  onSpecialistAudioVolumePercentageChange?: (volumePercentage: number) => void
}

interface RRWebPlayerState {
  playerMuted: boolean
  playerVolume: number
  handlePlayerVolumeChange: (_event: Event, newValue: number | number[]) => void
  handleTogglePlayerMute: () => void
  specialistAudioMuted: boolean
  specialistAudioVolume: number
  handleSpecialistAudioVolumeChange: (_event: Event, newValue: number | number[]) => void
  handleToggleSpecialistAudioMute: () => void
}

export const useRRWebPlayerState = ({
  initialVolumePercentage = MAX_VOLUME / 100,
  onPlayerVolumePercentageChange,
  onSpecialistAudioVolumePercentageChange
}: RRWebPlayerStateOptions): RRWebPlayerState => {
  const [playerMuted, setPlayerMuted] = useState(false)
  const [playerVolume, setPlayerVolume] = useState(normalizeVolume(initialVolumePercentage * 100))

  const handlePlayerVolumeChange = (_event: Event, newValue: number | number[]) => {
    const newVolume = newValue as number
    onPlayerVolumePercentageChange?.(newVolume / 100)
    setPlayerVolume(newVolume)
    setPlayerMuted(false)
  }

  const handleTogglePlayerMute = () => {
    setPlayerMuted(previouslyMuted => {
      if (previouslyMuted) {
        onPlayerVolumePercentageChange?.(playerVolume / 100)
        return false
      } else {
        onPlayerVolumePercentageChange?.(0)
        return true
      }
    })
  }

  const [specialistAudioMuted, setSpecialistAudioMuted] = useState(true)
  const [specialistAudioVolume, setSpecialistAudioVolume] = useState(normalizeVolume(initialVolumePercentage * 100))

  const handleSpecialistAudioVolumeChange = (_event: Event, newValue: number | number[]) => {
    const newVolume = newValue as number
    onSpecialistAudioVolumePercentageChange?.(newVolume / 100)
    setSpecialistAudioVolume(newVolume)
    setSpecialistAudioMuted(false)
  }

  const handleToggleSpecialistAudioMute = () => {
    setSpecialistAudioMuted(previouslyMuted => {
      if (previouslyMuted) {
        onSpecialistAudioVolumePercentageChange?.(specialistAudioVolume / 100)
        return false
      } else {
        onSpecialistAudioVolumePercentageChange?.(0)
        return true
      }
    })
  }

  return {
    playerMuted,
    playerVolume,
    handlePlayerVolumeChange,
    handleTogglePlayerMute,
    specialistAudioMuted,
    specialistAudioVolume,
    handleSpecialistAudioVolumeChange,
    handleToggleSpecialistAudioMute
  }
}
